<template>
  <b-row>
    <b-card class="wiwi p-0 m-0">
      <b-card-body class="p-0 m-0">
        <!-- The Active Tab interpolated here ensures the onUpdate lifecycle hook is always called when the tab Changes.-->
        <!-- Adding the 'hidden' class makes sure the user does not get to see it -->
        <!-- <p class="hidden">{{ activeTab }}</p> -->
        <!-- ':tabName' passes the current tab name to the Question Component. ':currentTab' passes the current Tab index to the Question Component -->
        <!-- ':tabsCount' passes the the number of Tabs in the testhall to the Question component -->
        <!-- ':keysubmit' & ':opencalc' listens for events ( 's'pressed & 'm' pressed) occurrence in the chilld component emits --> 
        <!-- corresponding events to the parent Component (Testhall) to perform corresponding actions when keys are pressed-->
        <!-- ':prevtab' & ':nexttab' listens to events ( 'p' key pressed and 'n' key pressed) and emits corresponding events to the parent(Testhall) component-->
        <untabbedQuestion :tabName="currentTab" v-on:keysubmit="$emit('keysubmitnow')" v-on:opencalc="$emit('opencalcnow')" :changeQuestion="changeQuestion"></untabbedQuestion>
      </b-card-body>
    </b-card>
  </b-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
import untabbedQuestion from "@/components/untabbedQuestion.vue";

export default {
  components: {
    untabbedQuestion
  },
  props: ["changeQuestion"],
  data() {
    return {
      cqindex: 1,
      currentQuestion: this.currentQue,

      cheket: ""
    };
  },
  created() {
      // Forces the MathJax Library on the Testhall to allow for easy showing of Complex equations. 
      // This is done because of Chromium Browsers that doesn't allow MathML show on their  browsers
      window.MathJax = { MathML: { extensions: ["mml3.js", "content-mathml.js"]}};
      let externalScript = document.createElement('script')
      externalScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=MML_HTMLorMML')
      document.head.appendChild(externalScript)
  },
  mounted() {
    // Forces the MathJax Library on the Testhall to allow for easy showing of Complex equations. 
    // This is done because of Chromium Browsers that doesn't allow MathML show on their  browsers
    window.MathJax = { MathML: { extensions: ["mml3.js", "content-mathml.js"]}};
    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=MML_HTMLorMML')
    document.head.appendChild(externalScript)
    

    this.changeTabs(); // Call the ChangeTabs when the Component is mounted

  },

  methods: {
    ...mapActions("exam", ["setSubject", "setTabQuestions"]),
    currentTabQuestions() {
      this.currentQuestion = this.questions
    },
    changeTabs(){
        // Gets the active tabName from the subjects Array using the index as the activeTab prop
        // const tabName = this.subjects[this.activeTab];

        // Get all the Questions for the Current Tab from the questions Array
        const currentTabQuestions = this.questions;
        this.setTabQuestions(currentTabQuestions); // update the Questions Array in the Store
        // this.setSubject(tabName); // Update the Subject Array in the Store
    }
  },
  computed: {
    ...mapState({
      subjects: state => state.exam.subjects,
      questions: state => state.exam.question,
      currentQue: state => state.exam.currentquestion
    })
  },
  watch: {
      // watch the activeTab for changes. Call the 'changeTab' method when tab a new tab index is passed to this conmponent
      activeTab(){
          this.changeTabs();
      }
  }
};
</script>

<style scoped>
.wiwi {
  width: 100%;
  padding: 30px;
  margin: 0px;
}
.hidden {
  display: none;
}
</style>
